// extracted by mini-css-extract-plugin
export default {"description":"EpqKOK","link":"aI5RG1"};